import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export interface GoalInfo {
  id: number;
  category: string;
  goal: string;
  goal_type: string;
  target_date: string;
  motivationtype: string;
  proficiency: number | null;
  weekly_target_hours: [string, string][];
  holiday_weekly_target_hours: [string, string][];
  ai_request: string;
}

export interface AiPlanStatus {
  planType: string;
  remainingCount: number;
}

export const registGoal = async (token: string, value: GoalInfo) => {
  return await apiFetch(`${API_BASE}/api/management/regist-goal`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  });
};

export const updateGoal = async (token: string, value: GoalInfo) => {
  return await apiFetch(`${API_BASE}/api/management/edit-goal/${value.id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  });
};

export const getUserGoalByPlanId = async (token: string, planId: number) => {
  return await apiFetch(`${API_BASE}/api/management/ai-plans/${planId}/user-goal`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export async function getUserGoalCount(token: string): Promise<number> {
  return await apiFetch(`${API_BASE}/api/management/goal-count`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const getGoals = async (token: string) => {
  return await apiFetch<GoalInfo[]>(`${API_BASE}/api/management/goals`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAiPlanStatus = async (token: string): Promise<AiPlanStatus> => {
  return await apiFetch<AiPlanStatus>(`${API_BASE}/api/management/ai-plan-status`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};